import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {GrPagination} from '../../../../interfaces/general-interfaces';
import {Subscription} from 'rxjs';
import {NotificationsHttpService} from '../../../../services/http-services/notifications/notifications-http.service';
import {WebsocketsHelperService} from '../../../../services/helpers/websockets-helper.service';
import {NgClass, NgForOf} from '@angular/common';
import {TimeAgoPipe} from '../../../../pipes/time-ago/time-ago.pipe';
import {NotificationsModelTypeAdmin} from '../../../../enums/notification-enums';
import {NotificationsHelperService} from '../../../../services/helpers/notifications-helper.service';

@Component({
  selector: 'gr-notification-payment-tab',
  standalone: true,
  templateUrl: './notification-payment-tab.component.html',
  imports: [
    NgForOf,
    TimeAgoPipe,
    NgClass
  ]
})
export class NotificationPaymentTabComponent implements OnInit, OnDestroy {
  urlParams = {page: 1};
  notificationsPagination: GrPagination | undefined;
  notifications: any[] = [];
  notificationsCount = 0;
  isRequestFinish = false;
  wsNotificationsSubscription = new Subscription();
  @Output() paymentNotificationsCount: EventEmitter<number> = new EventEmitter<number>();

  constructor(private notificationsHttpService: NotificationsHttpService,
              private websocketsHelperService: WebsocketsHelperService,
              private notificationsHelperService: NotificationsHelperService) {}

  ngOnInit(): void {
    this.notificationsPagination = undefined;
    this.notifications = [];
    this.getPaymentNotifications();
    this.wsNotificationsSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
      if (res.type === NotificationsModelTypeAdmin.reservationCreatedAdmin) {
        this.paymentNotificationsCount.emit(this.notificationsCount + 1);
        this.notifications.unshift({
          read_at: null,
          data: {data: res.data, id: res.data.id, created_at: res.created_at}
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.wsNotificationsSubscription.unsubscribe();
  }

  getPaymentNotifications(): void {
    this.urlParams.page = this.notificationsPagination?.currentPage ? this.notificationsPagination.currentPage + 1 : 1;
    this.notificationsHttpService.getReservationsNotifications(this.urlParams).then((res: any) => {
      this.notifications = [...this.notifications, ...res.data];
      this.notificationsPagination = res.pagination;
      this.notificationsCount = res.unreadCount;
      this.paymentNotificationsCount.emit(this.notificationsCount);
      this.isRequestFinish = true;
    });
  }

  clickOnNotification(notification: any): void {
    if (notification.read_at === null) {
      this.paymentNotificationsCount.emit(--this.notificationsCount);
      this.notificationsHelperService.clickOnUnreadNotification();
      notification.read_at = Date.now();
      this.notificationsHttpService.postReservationsReadNotification({notificationId: notification.id}).then(res => {});
    }
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;
    if (position > height - threshold && (this.notificationsPagination?.currentPage ?? 0) < (this.notificationsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.isRequestFinish = false;
      this.getPaymentNotifications();
    }
  }
}
